import { ensureNamespace } from '@/lib/i18n/runtime'
import { createFileRoute } from '@tanstack/react-router'
import { FilesPage } from '@/features/files/components/FilesPage'

export const Route = createFileRoute('/_auth/files')({
  beforeLoad: async () => { await Promise.all([ensureNamespace('shell'), ensureNamespace('files')]).catch(() => { /* Boundary offers retry. */ }); },
  component: FilesPage,
})
